/**
 * Inspired by https://github.com/helpers/handlebars-helpers
 */
require([
    'handlebars',
    'moment'
], function(
    Handlebars,
    moment
) {
    /**
     * Encodes a Uniform Resource Identifier (URI) component
     * by replacing each instance of certain characters by
     * one, two, three, or four escape sequences representing
     * the UTF-8 encoding of the character.
     *
     * @param  {String} `str` The un-encoded string
     * @return {String} The endcoded string
     */
    Handlebars.registerHelper('encodeURI', function (string) {
        return encodeURIComponent(string);
    });

    /**
     * Formats the given number using fixed-point notation.
     *
     * ```handlebars
     * {{toFixed "1.1234" 2}}
     * //=> '1.12'
     * ```
     * @param {Number} `number`
     * @param {Number} `digits` (Optional) The number of digits to appear after the decimal point; this may be a value between 0 and 20. If this argument is omitted, it is treated as 0.
     * @return {String} A string representing the given number using fixed-point notation.
     * @api public
     */
    Handlebars.registerHelper('toFixed', function (number, digits) {
        number = parseFloat(number);
        if (!number) {
            number = 0;
        }
        digits = parseInt(digits);
        if (!digits) {
            digits = 0;
        }
        return Number(number).toFixed(digits);
    });

    /**
     * format date to provided format
     *
     * @param  {String} The date string
     * @param  {String} The date format string
     * @return {String} The formatted date string
     */
    Handlebars.registerHelper('formatDate', function(dateString, format) {
        return new Handlebars.SafeString(
            moment(dateString).format(format)
        );
    });
});
